module.exports = __webpack_public_path__ + "static/img/Aaclogo5.3899585.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aaclogo5.png
// module id = pL2c
// module chunks = 1